// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1ZY-T","colCheckbox":"styles_colCheckbox__xQyet"};